export class OnrampError extends Error {
  constructor(message, code) {
    super(message);
    this.code = code;
  }
}

export const PARENT_MODEL_DETECTED_ERR_CODE = 'PARENT_MODEL_ERR_CODE'